import * as Yup from "yup";
import { formattedPhoneNumberLength } from "../../../utils/phoneNumberSupport";
import { validation, conditionalValidation } from "../../../utils/constants";
import moment from "moment";
export const OrganizationHeadCells = [
    {
        id: 'name',
        label: 'Name',
        type: 'text',
        nested: { key: "name" },
    },
    {
        id: 'state',
        label: 'Province/State',
        type: 'text',
        nested: { key: "address", value: { index: 0, key: "state" } },
    },
    {
        id: 'parent',
        label: 'Parent Organization',
        type: 'text',
        nested: { key: "partOf", value: { key: "display" } },
    },
    {
        id: 'actions',
        label: 'Actions',
        type: 'text',
        style: { textAlign: "center" },
    },
];
export const SAMLHeadCells = [
    {
        id: 'provider-name',
        label: 'Provider Name',
        type: 'text',
    },
    {
        id: 'createdAt',
        label: 'Created At',
        type: 'text',
    },
    {
        id: 'updatedAt',
        label: 'Updated At',
        type: 'text',
    }
];
export const OrganizationDataFields = [
    'name',
    'state',
    'parent',
    "actions"
];

export const SAMLDataFields = [
    'provider-name',
    'createdAt',
    'updatedAt',
];

export const filterStatusOptions = [ 
    { name: "Active", "value": "true" },
    { name: "Inactive", "value": "false" }
]
const validateImageDimensions = (minWidth, minHeight, maxWidth, maxHeight) => {
    return (value) => {
        if (!value) return true; // If no image is uploaded, validation passes
        const image = new Image();
        image.src = URL.createObjectURL(value);

        return new Promise((resolve) => {
            image.onload = () => {
                const width = image.width;
                const height = image.height;

                if (
                    width >= minWidth &&
                    height >= minHeight &&
                    width <= maxWidth &&
                    height <= maxHeight
                ) {
                    resolve(true); // Image dimensions are within the specified range
                } else {
                    resolve(false); // Image dimensions are not within the specified range
                }
            };
        });
    };
};

export const FormikObj = {
    initialValues: {
        name: "",
        active: true,
        address: "",
        state: "",
        country: "",
        city: "",
        postalCode: "",
        phone_number: "",
        ext: "",
        email: "",
        description: "",
        appointment_cancel_time: "1",
        typeOfDeviceUnitType: "",
        deviceUnitType: "",
        oxygen: "",
        heart_rate: "",
        weight: "",
        temperature: "",
        blood_pressure: "",
        blood_glucose: "",
        orgLogoURL: "",
        isWaitingRoom: false,
        hoursOfOperation: false,
        satisfactionSurvey: false,
        survey: "optional",
        sftEnabled: false,
        mfaEnabled: true,
        expirationDays: 1,
        privacyStatement: "",
        supportStatement: "",
        patientApptAutoAcceptance: false,
        practitionerApptAutoAcceptance: false,
        dni: [""],
        isCtiEnabled: false,
        initialAssessmentQuestion: true,
        organization: "",
        ecrIdentifier: "",
        encounterReportPrivacyStatement: "This information may have been disclosed to you from records whose confidentiality is protected by Federal law, which prohibits you from further disclosing it without the written consent of the person to whom it pertains or as otherwise permitted by Federal Regulations. If you receive this in error, please contact us immediately.",
        faxCoverPrivacyStatement: "By accepting this information, you acknowledge and agree to assume full responsibility for its protection in compliance with relevant laws and regulations. We shall not be liable for any special direct, indirect, consequential, or incidental damages arising from or related to your use of the information post-receipt. If you are not the intended recipient, you are hereby informed that any review, dissemination, distribution, or duplication of this information is strictly prohibited. Please promptly notify us and securely dispose of all copies if you are not the intended recipient."

        
    },
}

export const getValidationSchema = (selectedTab) => {
    switch (selectedTab) {
        case "Details":
            return Yup.object({
                name: conditionalValidation(
                    Yup.string().max(100, "Must be 100 characters or less").matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
                    {
                        validation,
                        label: "Name",
                        mandatory: true
                    }),
                description: conditionalValidation(
                    Yup.string().max(200, "Must be 200 characters or less").matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
                    {
                        validation,
                        label: "Organization"
                    }),
                address: conditionalValidation(
                        Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
                        {
                            validation,
                            label: "Address",
                            mandatory: true
                        }),
                state: conditionalValidation(
                        Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
                        {
                            validation,
                            label: "State/Province",
                            mandatory: true
                        }),
                country: conditionalValidation(
                    Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
                    {
                        validation,
                        mandatory: true,
                        label:"Country"
                    }),
                city: conditionalValidation(
                    Yup.string().required("Required city field").matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
                    {
                        validation,
                        mandatory: true,
                        label:"City"
                    }),
                postalCode: Yup.string().when(["type", "country"], (type, country, schema) =>
                    conditionalValidation(
                        country === "US"
                        ? Yup.number()
                            .typeError("Zip code must be a number")
                        : Yup.string()
                            .matches(
                            /^[A-Za-z]\d[A-Za-z] [0-9][A-Za-z]\d$/,
                            "Postal code must be in A1A 1A1 format."
                            ),
                        {
                            validation,
                            mandatory: true,
                            label: (country === "US")? "Zip code":"Postal code"})
                ),
                phone_number: conditionalValidation(
                    Yup.string()
                        .matches(
                        /^(?:\+?1[-. ]?)?\(?\d{3}\)?[-. ]?\d{3}[-. ]?\d{4}$/,
                        "Enter Valid Phone Number."
                        )
                        .test(
                        "is-valid-or-empty-placeholder",
                        "Enter Valid Phone Number.",
                        (value) => {
                            if (value && value.trim() === "(___) ___-____") return true; // allow placeholder
                            return /^(?:\+?1[-. ]?)?\(?\d{3}\)?[-. ]?\d{3}[-. ]?\d{4}$/.test(value);
                            }
                        ),
                        {
                            validation,
                            mandatory: true,
                            label: "Phone Number"}),
                // TODO Multilingual Support
                ext: conditionalValidation(
                    Yup.string().matches(/^\d{0,4}$/, "Must be 4 digits or less."),
                    { validation }
                ),
                email: conditionalValidation(
                    Yup.string().email("Invalid email address").matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
                    {
                        validation,
                        mandatory: true,
                        label: "Email"
                    }),
                orgLogoURL: Yup.mixed()
                .test("fileSize", "The file size should be up to 2 MB.", (value) => {
                    return value ? (value.size <= 2 * 1024 * 1024) : true;
                })
                .test("type", "Only the .jpg or .png format is acceptable", (value) => {
                    if (!value) return true;
                    const acceptedFormats = ["image/jpeg", "image/png"];
                    return acceptedFormats.includes(value.type);
                })
                // .test(
                //     "dimensions",
                //     "Image dimensions must be under 300 x 200 pixels",
                //     validateImageDimensions(100, 100, 300, 200)
                // ),
            });
        case "Virtual Visit":
            return Yup.object({
                isWaitingRoom: Yup.boolean(),
                hoursOfOperation: Yup.boolean(),
                patientApptAutoAcceptance: Yup.boolean(),
                practitionerApptAutoAcceptance: Yup.boolean(),
                appointment_cancel_time: Yup.number().typeError("Appointment cancellation time must be a number").min(1, "Minimum 1 minute").required("Required appointment cancellation time field"),
            });
        case "RPM":
            return Yup.object({
                typeOfDeviceUnitType: conditionalValidation(
                    Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
                    {
                        label: "Device Unit Type",
                    }),

                deviceUnitType: conditionalValidation(
                    Yup.string().when("typeOfDeviceUnitType", (typeOfDeviceUnitType, schema) =>
                    typeOfDeviceUnitType === "group"
                        ? schema.required("Required Device Unit Type field")
                        : schema),
                        {
                            label: "Device Unit Type"                    
                        }),
                oxygen: conditionalValidation(
                    Yup.string().when("typeOfDeviceUnitType", (typeOfDeviceUnitType, schema) =>
                        typeOfDeviceUnitType === "individual"
                            ? schema.required("Required field")
                            : schema)),
                heart_rate: conditionalValidation(
                    Yup.string().when("typeOfDeviceUnitType", (typeOfDeviceUnitType, schema) =>
                        typeOfDeviceUnitType === "individual"
                            ? schema.required("Required field")
                            : schema)),
                weight: conditionalValidation(
                    Yup.string().when("typeOfDeviceUnitType", (typeOfDeviceUnitType, schema) =>
                        typeOfDeviceUnitType === "individual"
                            ? schema.required("Required field")
                            : schema)),
                temperature: conditionalValidation(
                    Yup.string().when("typeOfDeviceUnitType", (typeOfDeviceUnitType, schema) =>
                        typeOfDeviceUnitType === "individual"
                            ? schema.required("Required field")
                            : schema)),
                blood_pressure: conditionalValidation(
                    Yup.string().when("typeOfDeviceUnitType", (typeOfDeviceUnitType, schema) =>
                        typeOfDeviceUnitType === "individual"
                            ? schema.required("Required field")
                            : schema)),
                blood_glucose: conditionalValidation(
                    Yup.string().when("typeOfDeviceUnitType", (typeOfDeviceUnitType, schema) =>
                        typeOfDeviceUnitType === "individual"
                            ? schema.required("Required field")
                            : schema)),
            });
        case "File Transfer":
            return Yup.object({
                privacyStatement: conditionalValidation(
                    Yup.string().when("sftEnabled", (sftEnabled , schema)=> 
                    sftEnabled === true 
                    ? Yup.string().required("Required Privacy Statement field"). max(10000, "Must be 10000 characters or less") : schema
                    ),
                    {
                        validation,
                        label: "Privacy Statement"
                    }),
                supportStatement: conditionalValidation(
                    Yup.string().when("sftEnabled", (sftEnabled, schema )=> 
                    sftEnabled === true 
                    ? Yup.string().required("Required Support Statement field"). max(10000, "Must be 10000 characters or less") : schema
                    ),
                    {
                        validation,
                        label: "Support Statement"
                    }),        
                expirationDays: Yup.number().when("sftEnabled", (sftEnabled , schema)=> 
                sftEnabled === true 
                    ? Yup.number().required("Required Expiration Days field").typeError("Expiration days must be a number")
                    .integer("Expiration days must be an integer")
                    .min(1, "Expiration days must be between 1 to 7.")
                    .max(7, "Expiration days must be between 1 to 7.") : schema
                    ),
            });
        case "CTI": 
            return Yup.object({
                dni: Yup.array()
                        .of(
                        Yup.string()
                            .matches(/^\d{10}$/, 'DNI must be exactly 10 digits')
                            .required('DNI is required')
                        )
                        })
        case "Privacy Statements":
            return Yup.object({
                encounterReportPrivacyStatement: conditionalValidation(
                    Yup.string().max(600, "Must be 600 characters or less"),
                    {
                        validation,
                        mandatory: true,
                        label: "Encounter Report Privacy Statement"
                    }),
                faxCoverPrivacyStatement: conditionalValidation(
                    Yup.string().max(1000, "Must be 1000 characters or less"),
                    {
                        validation,
                        mandatory: true,
                        label:"Fax Cover Letter Privacy Statement"
                    })
            })
        case "Client Registry": 
            return Yup.object({
                ecrIdentifier: conditionalValidation(
                    Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
                    {
                        validation,
                        mandatory: false,
                        label: "Client Registry Identifier"
                    }
                )
            })
        default:
            return Yup.object({});
    }
};

export const filterKeysFunc = (parentId, selectedId, parentInputsValue, selectedData) => {
    return Object.keys(parentInputsValue).filter((key) => selectedData.includes(key))
        .reduce((obj, key) => {
            if (key === parentId) {
                return Object.assign(obj, { [key]: selectedId });
            }
            return Object.assign(obj, { [key]: parentInputsValue[key] });
        }, {});
}

export const typeOfDeviceUnitTypeOptions = [
    { value: "group", name: "Group" },
    { value: "individual", name: "Individual" },
]
export const deviceUnitTypeOptions = [
    { value: "canadian", name: "Canadian(°C, KG, mmol/L, mmHg, SpO2%, bpm)" },
    { value: "american", name: "American(°F, LBS, mg/dL, mmHg, SpO2%, bpm)" },
]
export const devicesField = [
    {
        formikKey: "blood_glucose", name: "Blood Glucose", options: [
            { value: "mmol/L", name: "mmol/L" },
            { value: "mg/dL", name: "mg/dL" },]
    },
    {
        formikKey: "blood_pressure", name: "Blood Pressure", options: [
            { value: "mmHg", name: "mmHg" }
        ]
    },
    {
        formikKey: "temperature", name: "Temperature", options: [
            { value: "°C", name: "°C" },
            { value: "°F", name: "°F" },
        ]
    },
    {
        formikKey: "weight", name: "Weight", options: [
            { value: "kg", name: "kg" },
            { value: "lbs", name: "lbs" },
        ]
    },
    {
        formikKey: "oxygen", name: "Oxygen", options: [
            { value: "SpO2%", name: "SpO2%" },
        ]
    },
    {
        formikKey: "heart_rate", name: "Heart Rate", options: [
            { value: "bpm", name: "bpm" },
        ]
    },
]

export const ORGANIZATION_DETAILS = "Organization Details";
export const PARENT_ORGANIZATION = "Parent Organization";
export const NAME = "Name";
export const DESCRIPTION = "Description";
export const ADDRESS = "Address";
export const COUNTRY = "Country";
export const STATE = "State";
export const CITY = "City";
export const ZIP_CODE = "Zip Code";
export const POSTAL_CODE = "Postal Code";
export const PHONE_NUMBER = "Phone Number";
export const EXT = "Ext.";
export const EMAIL_ADDRESS = "Email Address";
export const APPOINTMENT_CANCEL_TIME = "Appointment Cancel Time (Mins)";
export const DEVICE_UNIT_TYPE = "Device's unit Type";
export const TYPE = "Type";
export const WAITING_ROOM_FACILITY = "Waiting Room Facility";
export const CANCEL = "Cancel";
export const UPDATE = "Update";
export const CREATE = "Create";

export const operationTiming = {
    Monday: {
        startTime: null,
        endTime: null
    },
    Tuesday: {
        startTime: null,
        endTime: null
    },
    Wednesday: {
        startTime: null,
        endTime: null
    },
    Thursday: {
        startTime: null,
        endTime: null
    },
    Friday: {
        startTime: null,
        endTime: null
    },
    Saturday: {
        startTime: null,
        endTime: null
    },
    Sunday: {
        startTime: null,
        endTime: null
    }
}

export const timeSelectorStyle = {
    height: "100%",
    verticalAlign: "middle",
    display: "flex",
    alignItems: "center",
    fontWeight: 500
}

export function transformTimingData(waitingRoomTimings) {
    const daysOfWeek = [
        "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
    ];

    const operationTiming = daysOfWeek.map(day => {
        const startTime = waitingRoomTimings[day].startTime;
        const endTime = waitingRoomTimings[day].endTime;
        // Format startTime and endTime here as needed            
        const formattedStartTime = startTime !== null ? startTime.utc() : "";
        const formattedEndTime = endTime !== null ? endTime.utc() : "";
        return {
            weekDay: day,
            startTime: formattedStartTime,
            endTime: formattedEndTime,
        };
    });

    return operationTiming;
}

export function getDeviceUnit(values) {
    return {
        type: values.typeOfDeviceUnitType,
        blood_glucose: {
            glucose: values.typeOfDeviceUnitType === "group"
                ? values.deviceUnitType === "canadian"
                    ? "mmol/L"
                    : "mg/dL"
                : values.blood_glucose,
        },
        temperature: {
            temperature: values.typeOfDeviceUnitType === "group"
                ? values.deviceUnitType === "canadian"
                    ? "°C"
                    : "°F"
                : values.temperature,
        },
        weight: {
            weight: values.typeOfDeviceUnitType === "group"
                ? values.deviceUnitType === "canadian"
                    ? "kg"
                    : "lbs"
                : values.weight,
        },
        oxygen: {
            oxygen: values.typeOfDeviceUnitType === "group" ? "SpO2%" : values.oxygen,
        },
        heart_rate: {
            heartRate: values.typeOfDeviceUnitType === "group" ? "bpm" : values.heart_rate,
        },
        blood_pressure: {
            diastolic: values.typeOfDeviceUnitType === "group"
                ? "mmHg"
                : values.blood_pressure,
            systolic: values.typeOfDeviceUnitType === "group"
                ? "mmHg"
                : values.blood_pressure,
        },
    };
}
